module.exports = __webpack_public_path__ + "img/aqsc.d99c61e0.png";